module.exports = __webpack_public_path__ + "97919705.svg";